import axios from "axios";
import { API_URL } from "./apiUrl";

// export const API_URL = 'https://montenegromice.com/mice-api';

export const fetchDistanceSections = () => {
  return axios
    .get(`${API_URL}/distance-section`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const deleteDistanceSection = (distanceSectionId) => {
  return axios
    .delete(`${API_URL}/distance-section/${distanceSectionId}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Greška pri brisanju dokumenta: ${error.message}`);
    });
};

export const getDistanceSection = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/distance-section/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(`Greška pri dobavljanju dokumenta: ${error.message}`);
  }
};

export const editDistanceSection = async (id, distanceSectionData) => {
  try {
    const response = await axios.put(
      `${API_URL}/distance-section/${id}`,
      distanceSectionData
    );
    return response.data;
  } catch (error) {
    throw new Error(`Greška pri editovanju dokumenta: ${error.message}`);
  }
};

export const addDistanceSection = (distanceSectionData) => {
  return axios
    .post(`${API_URL}/distance-section`, distanceSectionData)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Greška pri dodavanju dokumenta: ${error.message}`);
    });
};
